// rotating svg

 const svgElement = document.querySelectorAll('.rotating_svg');
    window.addEventListener('scroll', () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = window.scrollY / scrollableHeight;
      const rotation = scrollPercent * 360 * 3;
      svgElement.forEach((svgElements) => {
      svgElements.style.transform = `rotate(${rotation}deg)`;
    });
  });

// flavouresof PDP

// $(".main_flavoured .tabs").wrapAll("<div class='main_wraped_flavours' />");
// const flavoureTabs = document.querySelectorAll(".main_flavoured .tabs");
// const mainFlavours = document.querySelectorAll(".main_flavoured");
// flavoureTabs.forEach((tab, i) => {
//   tab.addEventListener('click', () => {
//     document.querySelector(".main_flavoured .tabs.active")?.classList.remove("active");
//     document.querySelector(".main_flavoured.active")?.classList.remove("active");
//     tab.classList.add("active");
//     mainFlavours[i].classList.add("active");
//   });
// });
// flavoureTabs[0]?.click();

$(".main_flavoured .tabs").wrapAll("<div class='main_wraped_flavours' />");
const flavoureTabs = document.querySelectorAll(".main_flavoured .tabs");
const mainFlavours = document.querySelectorAll(".main_flavoured");
// Retrieve saved tab index from localStorage
const savedTabIndex = localStorage.getItem("activeTabIndex");
// Set active tab function
const setActiveTab = (index) => {
  document.querySelector(".main_flavoured .tabs.active")?.classList.remove("active");
  document.querySelector(".main_flavoured.active")?.classList.remove("active");
  flavoureTabs[index]?.classList.add("active");
  mainFlavours[index]?.classList.add("active");
  // Save active tab index to localStorage
  localStorage.setItem("activeTabIndex", index);
};
// Add event listeners to tabs
flavoureTabs.forEach((tab, i) => {
  tab.addEventListener("click", () => setActiveTab(i));
});
// Set the saved tab or default to the first tab
setActiveTab(savedTabIndex ? parseInt(savedTabIndex) : 0);
